import React, { ComponentProps, useState } from "react";
import { Box, Button, H3, H4, HStack, Icon, ScrollView, Spinner, Typography, View } from "components/ui";
import Modal from "react-native-modal/dist/modal";
import { X } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";

type PopupModalProps = Partial<React.ComponentProps<typeof Modal>> & {
	children: React.ReactNode;
	title?: string;
	isLoading?: boolean;
	viewHeight?: number | "auto";
	maxWidth?: number;
};
const PopupModal = (props: PopupModalProps) => {
	const resolvedPrimaryLight = useToken("colors", "primarylight");
	const isAutoHeight = props.viewHeight === "auto";

	return (
		<Modal style={{ maxWidth: props.maxWidth || 1240, marginLeft: "auto", marginRight: "auto", width: "100%" }} {...props}>
			<View bg="$basicwhite" overflow={isAutoHeight ? "visible" : "hidden"} borderRadius={12} height={isAutoHeight ? "auto" : props.viewHeight || 700}>
				<HStack alignItems="center" borderTopLeftRadius={12} borderTopRightRadius={12} justifyContent="space-between" bg="$lighttealxlight" paddingHorizontal={28} paddingVertical={20}>
					<H3>{props.title}</H3>
					<Box>
						<Button onPress={props.onBackdropPress} gap={6}>
							<Icon as={X} />
							<Typography>Close</Typography>
						</Button>
					</Box>
				</HStack>
				{isAutoHeight ? (
					<Box padding={28}>
						{props.isLoading ? (
							<Box paddingBlock={24} minHeight={200} justifyContent="center" alignItems="center" width={"$full"} height={"$full"}>
								<Spinner style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} size={"large"} color={resolvedPrimaryLight} />
							</Box>
						) : (
							props.children
						)}
					</Box>
				) : (
					<ScrollView sx={{ width: "100%", height: 400, padding: 28 }}>
						{props.isLoading ? (
							<Box paddingBlock={24} minHeight={200} justifyContent="center" alignItems="center" width={"$full"} height={"$full"}>
								<Spinner style={{ transform: [{ scaleX: 2 }, { scaleY: 2 }] }} size={"large"} color={resolvedPrimaryLight} />
							</Box>
						) : (
							props.children
						)}
					</ScrollView>
				)}
			</View>
		</Modal>
	);
};

export default PopupModal;
